import React from 'react';

export default class OptGroup extends React.Component {
  static isSelectOptGroup = true;
}



// WEBPACK FOOTER //
// ./_rc-select-7.5.0/src/OptGroup.jsx